<template>
  <div class="activity-order-list-page">
    <dol-list
        class="dol-data-list"
        :title="$t('租赁_活动订单')"
        :columns="columns"
        dot-net-query-type="4100"
        dotNetReturnListField="OT_SHEET_MASTER"
        :dot-net-table-type="4"
        :query-data="queryForm"
        row-key="FLOW_ID"
        pagination-type="local"
        ref="list"
        :scroll-x="true"
        :selected-row-keys.sync="selectedRowKeys"
        :selected-rows.sync="selectedRows"
    >
      <template #extra>
        <dol-select
            class="conditionFieldSelect"
            v-model.trim="showQueryFormField"
            source="local"
            :default-data="queryFormFieldOptions"
            mode="multiple"
            :max-tag-count="1"
            :placeholder="$t('queryCondition')"
            @change="pickConditionField"
        />
      </template>
      <template #queryForm>
        <a-form layout="inline">
          <a-form-item>
            <cargo-box-line-operation
                :disabled="selectedRows.length === 0"
                :status="selectedRows.length === 0 ? null : selectedRows[0].XBXC_BOX_STATUS"
                :box-list="selectedRows"
                @refresh="$refs.list.load()"
            />
          </a-form-item>
          <a-form-item :label="$t('通用_单据号')">
            <a-input v-model.trim="queryForm['XB_SHEET_CODE']" @pressEnter="query"/>
          </a-form-item>
          <a-form-item :label="$t('通用_客户订单号')" v-if="showQueryFormField.includes('CUST_CODE')">
            <a-input v-model.trim="queryForm['CUST_CODE']" @pressEnter="query" />
          </a-form-item>
          <a-form-item :label="$t('putBoxOrderNumber')" v-if="showQueryFormField.includes('XE_SHEET_CODE')">
            <a-input v-model.trim="queryForm['SEND_CODE']" @pressEnter="query"/>
          </a-form-item>
          <a-form-item :label="$t('通用_箱号')" v-if="showQueryFormField.includes('BOX_CODE')">
            <a-input v-model.trim="queryForm['BOX_CODE']" @pressEnter="query"/>
          </a-form-item>
          <a-form-item :label="$t('通用_箱型')" v-if="showQueryFormField.includes('BOX_SIZE')">
            <dol-select
                v-model="queryForm.BOX_SIZE"
                source="server"
                server-type="DotNet"
                dot-net-table-name="BM_BASE_CODE"
                :label-field="$kt('CODE_NAME')"
                key-field="CODE_ID"
                value-field="CODE_ID"
                :query-data="$api.baseCode['10000011']"
            />
          </a-form-item>
          <a-form-item :label="$t('takeBoxPlace')" v-if="showQueryFormField.includes('CITY_ID')">
            <city-select v-model="queryForm['CITY_ID']" />
          </a-form-item>
          <a-form-item :label="$t('通用_还箱地')" v-if="showQueryFormField.includes('D_CITY_ID')">
            <city-select v-model="queryForm['D_CITY_ID']" />
          </a-form-item>
          <a-form-item :label="$t('expectedDateOfContainerUse')" v-if="showQueryFormField.includes('ESTIM_DATE')">
            <a-date-picker :placeholder="$t('pleaseSelectADate')" v-model.trim="queryForm['ESTIM_DATE']"/>
          </a-form-item>
          <a-form-item :label="$t('通用_箱状态')">
<!--            <dol-select v-model="queryBoxStatus" source="dict" dict-code="2045" />-->
            <dol-select v-model="queryBoxStatus" source="local" :default-data="showStatusOptions" />
          </a-form-item>
          <a-form-item :label="$t('applicationDate')" v-if="showQueryFormField.includes('XB_DATE')">
          <a-range-picker v-model="XB_DATE" :placeholder="[$t('通用_开始日期'), $t('通用_结束日期')]" ref="rangePicker"/>
        </a-form-item>
          <a-form-item :label="$t('lookOneself')">
            <a-switch default-checked @change="onChange"/>
          </a-form-item>

          <a-form-item>
            <a-space>
              <a-button type="primary" @click="query">{{ $t('search') }}</a-button>
              <a-button @click="clearObj">{{ $t('reset') }}</a-button>
            </a-space>
          </a-form-item>
        </a-form>
      </template>

      <template #city="field, record">
        {{ $dt(record, 'CITY_NAME') }}
        <a-icon style="margin: 0 4px" type="swap-right"/>
        {{ $dt(record, 'DIFF_CITY_NAME') || $dt(record, 'D_CITY_NAME') }}
        <template v-if="record.DIFF_CITY_NAME && record.DIFF_CITY_NAME !== record.D_CITY_NAME">
          <span class="text-middle-line">{{ $dt(record, 'D_CITY_NAME') }}</span>
        </template>
      </template>
      <template #ESTIM_DATE="field, record">
        {{ $moment(field).format('YYYY-MM-DD') }}
      </template>
      <template #orderStatus="field, record">
<!--        <dol-dict :value="field" dict-code="2044" />-->
        <dol-dict :value="showBoxStatus[field]" dict-code="2045" />
      </template>
      <template #operation="field, record">
        <a-space>
          <dol-button :title="$t('通用_详情')" @click="detail(record)"><a-icon type="search"/></dol-button>
          <cargo-box-line-operation type="single" :status="record.XBXC_BOX_STATUS" :box-list="[record]" @refresh="$refs.list.load()" />
        </a-space>
      </template>
    </dol-list>
  </div>
</template>

<script>
import commonErpPageScript from '@/components/common/commonErpPageScript';
import { mapState } from 'vuex';
import CargoBoxLineOperation from '@/views/order/orderListComponents/cargo-box-line-operation.vue';
import CitySelect from '@/components/contcircle/form/city-select.vue';
export default {
  name: "activityOrder",
  mixins: [commonErpPageScript],
  components: { CitySelect, CargoBoxLineOperation},
  data(){
    return {
      pageName: "activityOrder",
      queryForm: {
        QUERY_TYPE: 0, // 0货方查自己，1平台查货方
        BUSINESS_TYPE: 0, // 0活动订单，1历史订单，2终止订单
        COMPANY_ID: this.$store.state.userInfo.COMPANY_ID, // 公司ID（查询类型为0时，必填）
        XB_CREATE_BY: this.$store?.state?.userInfo?.USER_ID,
        XB_BEGIN_DATE: '',
        XB_END_DATE: '',
      },

      reasonVisible: false,
      selectedRowKeys: [],
      selectedRows: [],

      statusOptions: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
    columns () {
      let columns = [];
      // columns.push({dataIndex: 'SHEET_CODE', title: this.$t('orderID')});
      columns.push({ dataIndex: 'XB_SHEET_CODE', title: this.$t('通用_单据号') });
      columns.push({ dataIndex: 'SEND_CODE', title: this.$t('putBoxOrderNumber') }); // 放箱单号
      columns.push({ dataIndex: 'CUST_CODE', title: this.$t('通用_客户订单号') });
      columns.push({ dataIndex: 'ROUTE_QTY', title: this.$t('通用_订单箱量') });
      columns.push({ dataIndex: 'BOX_CODE', title: this.$t('通用_箱号') });
      columns.push({ dataIndex: this.$kt('GOODS_TYPE_NAME'), title: this.$t('goodsType') });
      columns.push({ dataIndex: this.$kt('CITY_NAME'), title: this.$t('takeBoxPlace') });
      columns.push({ dataIndex: this.$kt('D_CITY_NAME'), title: this.$t('通用_还箱地') });
      columns.push({ dataIndex: this.$kt('BOX_SIZE_NAME'), title: this.$t('通用_箱型'), width: 80 });
      columns.push({ dataIndex: 'ESTIM_DATE', title: this.$t('expectedDateOfContainerUse'), width: 140, scopedSlots: { customRender: 'ESTIM_DATE' } });
      columns.push({ dataIndex: 'XB_CREATE_BY_NAME', title: this.$t('通用_申请人') });
      columns.push({ dataIndex: 'XB_CREATE_DATE', title: this.$t('applicationDate'), scopedSlots: { customRender: 'iosDate' } });
      // columns.push({ dataIndex: 'XB_MEMO', title: this.$t('通用_申请备注') });
      // columns.push({ dataIndex: 'MEMO', title: this.$t('offerMemo') });
      // columns.push({dataIndex: this.$kt('OPER_STATUS_NAME'),fixed: 'right', title: this.$t('operationStatus'), scopedSlots: {customRender: 'OPER_STATUS_NAME'}});
      columns.push({ dataIndex: this.$kt('XBXC_BOX_STATUS'), fixed: 'right', title: this.$t('通用_箱状态'), scopedSlots: { customRender: 'orderStatus' } });
      columns.push({ dataIndex: '_id', width: '60px', fixed: 'right', scopedSlots: { customRender: 'operation' } });

      return columns;
    },
    queryFormFieldOptions () {
      let options = [];
      options.push({ code: 'CUST_CODE', text: this.$t('通用_客户订单号'), fields: ['CUST_CODE'] });
      options.push({ code: 'XE_SHEET_CODE', text: this.$t('putBoxOrderNumber'), fields: ['XE_SHEET_CODE'] });
      options.push({ code: 'BOX_CODE', text: this.$t('通用_箱号'), fields: ['BOX_CODE'] });
      options.push({ code: 'BOX_SIZE', text: this.$t('通用_箱型'), fields: ['BOX_SIZE'] });
      options.push({ code: 'CITY_ID', text: this.$t('takeBoxPlace'), fields: ['CITY_ID'] });
      options.push({ code: 'D_CITY_ID', text: this.$t('通用_还箱地'), fields: ['D_CITY_ID'] });
      options.push({ code: 'ESTIM_DATE', text: this.$t('expectedDateOfContainerUse'), fields: ['ESTIM_DATE'] });
      // options.push({ code: 'ORDER_STATUS', text: this.$t('通用_箱状态'), fields: ['ORDER_STATUS'] });
      options.push({ code: 'XB_DATE', text: this.$t('applicationDate'), fields: ['XB_DATE'] });
      return options;
    },
    XB_DATE: {
      get () {
        return this.queryForm.XB_BEGIN_DATE && this.queryForm.XB_END_DATE ? [
          this.$moment(this.queryForm.XB_BEGIN_DATE, 'YYYY-MM-DD'),
          this.$moment(this.queryForm.XB_END_DATE, 'YYYY-MM-DD')] : [];
      },
      set (rangeData) {
        if (rangeData && rangeData.length === 2) {
          this.queryForm.XB_BEGIN_DATE = rangeData[0].format('YYYY-MM-DD');
          this.queryForm.XB_END_DATE = rangeData[1].format('YYYY-MM-DD');
        } else {
          this.queryForm.XB_BEGIN_DATE = '';
          this.queryForm.XB_END_DATE = '';
        }
      },
    },
    queryBoxStatus: {
      get(){
        const matchStatus = this.statusConditionList.find(item => item.key === this.queryForm.XBXC_BOX_STATUS);
        if(matchStatus){
          return matchStatus.value;
        }else{
          return undefined;
        }
      },
      set(v){
        if(!v){
          this.$set(this.queryForm, 'XBXC_BOX_STATUS', undefined);
        }

        const matchStatus = this.statusConditionList.find(item => item.value === v);
        if(matchStatus){
          this.$set(this.queryForm, 'XBXC_BOX_STATUS', matchStatus.key);
        }else{
          this.$set(this.queryForm, 'XBXC_BOX_STATUS', undefined);
        }
      },
    },
    showBoxStatus(){
      const map = {};
      map['20441001'] = '20451001'; // 待匹配箱东 | 待审核
      map['20441002'] = '20451002'; // 待放箱
      map['20441003'] = '20451003'; // 待提箱
      map['20441004'] = '20451004'; // 待申请还箱
      map['20441005'] = '20451005'; // 待还箱指令
      map['20441006'] = '20451006'; // 待还箱
      map['20441007'] = '20451007'; // 待确认还箱日期
      map['20441008'] = '20451008'; // 还箱完成
      map['20441009'] = '20451009'; // 申请驳回 暂无
      map['20441010'] = '20451009'; // 申请取消 暂无
      map['20441011'] = '20451009'; // 订单作废 暂无
      map['20441012'] = '20451010'; // 异常 暂无
      map['20441013'] = '20451011'; // 灭失 暂无
      return map;
    },
    statusConditionList(){
      const list = [], map = {};
      const keyList = Object.keys(this.showBoxStatus);
      Object.values(this.showBoxStatus).forEach((value, index) => {
        if(map[value]){
          map[value].key += `,${keyList[index]}`;
        }else{
          map[value] = {key: keyList[index], value};
          list.push(map[value]);
        }
      });
      return list;
    },

    showStatusOptions(){
      return this.statusOptions.filter(item => item.code !== '20451008');
    }
  },
  methods:{
    detail(record){
      if(record.XC_MASTER_ID){
        this.$router.push(`/order/orderDetail?MASTER_ID=${record.XC_MASTER_ID}`)
      }else{
        this.$router.push(`/order/boxApplyForm?MASTER_ID=${record.XB_MASTER_ID}`)
      }
    },

    afterClearObj(data){
      data.QUERY_TYPE = 0; // 0货方查自己，1平台查货方
      data.BUSINESS_TYPE = 0; // 0活动订单，1历史订单，2终止订单
      data.COMPANY_ID = this.$store.state.userInfo.COMPANY_ID; // 公司ID（查询类型为0时，必填）
      data.XB_CREATE_BY = this.$store?.state?.userInfo?.USER_ID;
    },

    openPickupModel(){
      this.$refs.pickupRecord.open();
    },
    openExtensionModel(){
      this.$refs.extensionRequest.open();
    },
    openApplyReturnModel(){
      this.$refs.applyReturn.open();
    },
    onChange (v) {
      if (v) {
        this.queryForm.XB_CREATE_BY = this.$store?.state?.userInfo?.USER_ID;
      } else {
        this.queryForm.XB_CREATE_BY = '';
      }
    },
  },
  mounted() {
    this.$dict('2045').then(data => {
      this.statusOptions = data;
    });
  }
}
</script>

<style lang="scss">

</style>